import classnames from 'classnames'
import * as React from 'react'

import { Button, ButtonComponentProps, ButtonProps } from './button'
import { Paragraph } from './typography'

interface Props {
  children: (React.ReactElement | null)[]
  label?: string
  size?: ButtonProps['size']
  rounding?: ButtonProps['rounding']
}

export function ChipSwitch({ children, label, size, rounding }: Props) {
  return (
    <div className="flex items-center space-x-0.5">
      {label && (
        <Paragraph size="small" className="pr-1 text-disabled font-medium">
          {label}
        </Paragraph>
      )}

      {React.Children.map(
        children as Array<React.ReactElement<ButtonComponentProps> | null>,
        (child: React.ReactElement<ButtonComponentProps> | null) => {
          if (React.isValidElement(child) && child.type === Button) {
            return React.cloneElement(child, {
              size,
              rounding,
              theme: child.props.theme ?? 'chipTransparent',
              className: classnames(child.props.className, {
                // @todo - these style should be applied globally onto all chipTransparent buttons
                '!text-muted-2': !child.props.disabled && !child.props.active,
                '!text-default': !child.props.disabled && child.props.active,
                '!text-disabled ': child.props.disabled && !child.props.active,
                '!text-disabled !bg-gray-200 !bg-opacity-30 !border-gray-100 dark:!bg-gray-600 dark:!border-gray-500':
                  child.props.disabled && child.props.active,
              }),
            })
          }

          return child
        }
      )}
    </div>
  )
}

export const ChipSwitchButton = Button
